<template>
  <ul class="dropdown--content--list">


    <li
      v-for="(item, index) in list"
      v-bind:key="item.index"
      v-bind:data-index="index"
    >
      <span   
        v-if="(
          selectedApplicationName !== 'Alcohol app (Maxx)' 
          && (
            item.label === 'Issues'
            || item.label === 'Moments'
            || item.label === 'Situations'
            || item.label === 'MAXX'
          )
        )
        ||
        (
          selectedApplicationName !== 'Stopstone'
          && (
            item.label === 'Strategy'
            || item.label === 'Stopstone'
          )
        )"
      >
        {{ item.label }}
      </span>

      <a
        v-else
        :href="item.to"
      >
        {{ item.label }}
      </a>
    </li>



    <!-- <span
      v-for="(item, index) in list"
      v-bind:key="item.index"
      v-bind:data-index="index"
    >
      <li
        v-if="
          (
            selectedApplicationName === 'Alcohol app (Maxx)'
            && (
              item.label === 'Issues'
              || item.label === 'Moments'
              || item.label === 'Situations'
              || item.label === 'MAXX'
            )
          )
          ||
          (
            selectedApplicationName === 'Stopstone'
            && (
              item.label === 'Strategy'
              || item.label === 'Stopstone'
            )
          )
        "
      >
        <span
          v-if="item.istitle"
          class="dropdown--content--list--title"
        >
          {{ item.label }}
        </span>

        <a
          v-else
          :href="item.to"
        >
          {{ item.label }}
        </a>
      </li>
      
      <li
        v-if="
          item.label === 'Algemeen'
          || item.label === 'FAQ'
          || item.label === 'Text'
          || item.label === 'Tips'
          || item.label === 'Motivators'
        "
      >
        <span
          v-if="item.istitle"
          class="dropdown--content--list--title"
        >
          {{ item.label }}
        </span>

        <a
          v-else
          :href="item.to"
        >
          {{ item.label }}
        </a>
      </li>
    </span> -->

    <li v-if="list.length === 0">No results found 😟</li>
  </ul>
</template>

<script>
  export default {
    name: 'DropdownList',
    props: [
      'list'
    ],
    data() {
      return {
        selectedApplicationName: ''
      }
    },
    mounted() {
      // selected application
      if(localStorage.selectedApplicationName) {
        this.selectedApplicationName = localStorage.selectedApplicationName;
      }
    }
  }
</script>

<style lang="scss">
  .dropdown--content--list {  
    // max-height: 150px;
    overflow-y: scroll;

    &--title {
      font-weight: bold;
    }

    &--click {
      cursor: pointer;
    }

    li {
      padding: 5px 10px;

      span {
        color: var(--grey-normal);
      }

      a {
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>